import { useState, useEffect } from 'react';
import Button from '../../../components/base/Button';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [submitUrl, setSubmitUrl] = useState('');

  useEffect(() => {
    // Set the actual form URL
    setSubmitUrl('https://readdy.ai/api/form/d4a5gtj6dpbkhrueej50');
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (formData.message.length > 500) {
      setSubmitStatus('error');
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const formDataToSubmit = new URLSearchParams();
      formDataToSubmit.append('name', formData.name);
      formDataToSubmit.append('email', formData.email);
      formDataToSubmit.append('message', formData.message);

      const response = await fetch(submitUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSubmit.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-light mb-4" style={{ color: '#50686a' }}>
            Ready to Move Forward?
          </h2>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div>
            <form onSubmit={handleSubmit} className="space-y-6" data-readdy-form id="contact-form">
              <div>
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  className="w-full px-0 py-3 placeholder-gray-500 border-0 border-b focus:outline-none bg-transparent font-light"
                  style={{ 
                    color: '#50686a',
                    borderColor: '#98b8c1',
                    borderBottomWidth: '1px'
                  }}
                />
              </div>
              
              <div>
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="w-full px-0 py-3 placeholder-gray-500 border-0 border-b focus:outline-none bg-transparent font-light"
                  style={{ 
                    color: '#50686a',
                    borderColor: '#98b8c1',
                    borderBottomWidth: '1px'
                  }}
                />
              </div>
              
              <div>
                <textarea
                  name="message"
                  rows={4}
                  placeholder="Tell us about your project"
                  value={formData.message}
                  onChange={handleInputChange}
                  maxLength={500}
                  className="w-full px-0 py-3 placeholder-gray-500 border-0 border-b focus:outline-none bg-transparent resize-none font-light"
                  style={{ 
                    color: '#50686a',
                    borderColor: '#98b8c1',
                    borderBottomWidth: '1px'
                  }}
                />
                <div className="text-right text-xs mt-1" style={{ color: '#98b8c1' }}>
                  {formData.message.length}/500
                </div>
              </div>
              
              <div className="pt-4">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="px-8 py-3 text-lg font-medium text-white hover:opacity-90 transition-all whitespace-nowrap cursor-pointer rounded-full"
                  style={{ backgroundColor: '#607a7a' }}
                >
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>
              </div>
              
              {submitStatus === 'success' && (
                <div className="text-sm font-light" style={{ color: '#607a7a' }}>
                  Thank you! We'll get back to you within 24 hours.
                </div>
              )}
              
              {submitStatus === 'error' && (
                <div className="text-red-600 text-sm font-light">
                  Something went wrong. Please try again.
                </div>
              )}
            </form>
          </div>
          
          <div className="space-y-8">
            <div>
              <h3 className="text-lg font-medium mb-3" style={{ color: '#50686a' }}>Contact Information</h3>
              <div className="space-y-3 font-light" style={{ color: '#607a7a' }}>
                <p>+258 84 0190 377</p>
                <p>Rua dos Desportistas, JAT 6.1 • 3rd Fl Right, Maputo, Mozambique</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
